module.exports = __webpack_public_path__ + "img/plant_7_mobile.ab91ac7c.webp";